import { useEffect } from 'react';
import { formatDateTimeRangeFromString } from '../../../../helpers/date-time';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { DashboardType, FetchDashboardDataRequest } from '../../../../store/api/dashboard-api';
import { useDashboardStore } from '../../../../store/use-dashboard-store';
import { useLang } from '../../../../hooks/use-lang';

export const useFetchDashboardData = (
  dashboards: DashboardType[],
  extra_filters?: FetchDashboardDataRequest['extra_filters'],
) => {
  const { fetchDashboardData, list } = useDashboardStore();
  const { currentLang } = useLang();
  const params = useQueryParams().getQueryParams();
  const range = params.range ? JSON.parse(params.range) : null;
  const to = range?.to;
  const from = range?.from;
  const branch = params.branch;

  useEffect(() => {
    if (!branch) {
      return;
    }

    const formatted = formatDateTimeRangeFromString(JSON.stringify({ from, to }));

    fetchDashboardData({
      extra_filters,
      from: formatted?.from,
      to: formatted?.to,
      branch: branch,
      dashboards,
      language: currentLang,
    });
  }, [from, to, branch, JSON.stringify(extra_filters), currentLang]);

  return { list };
};
